export default "__VITE_ASSET__rvK2odE9__"